module.exports = __webpack_public_path__ + "images/4d177a14442e56d15d69c134d45f8b24.png";